import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "mt-15 mb-10 most-big-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('订单信息')))])]), _c('div', {
    staticClass: "list-row spec-cont"
  }, [_c('div', {
    staticClass: "list-row-tr"
  }, [_c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('订单号')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm.orderDetail.order_code))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('仓库（区域）')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(" " + _vm._s(_vm.orderDetail.warehouse_code) + " "), _vm.orderDetail.warehouse_name ? _c('span', [_vm._v("[" + _vm._s(_vm.orderDetail.warehouse_name) + "]")]) : _vm._e()])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('跟踪号')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.orderDetail.tracking_number)))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('实际重量（KG）')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.orderDetail.charge_info ? _vm.orderDetail.charge_info.real_weight : '')))])])]), _c('div', {
    staticClass: "list-row-tr"
  }, [_c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('订单参考号')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.orderDetail.reference_no)))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('销售平台')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.orderDetail.platform)))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('平台模式')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.orderDetail.extend_info && _vm.orderDetail.extend_info.property_label)))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('物流产品')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(" " + _vm._s(_vm.orderDetail.sm_code) + " "), _vm.orderDetail.sm_name ? _c('span', [_vm._v("[" + _vm._s(_vm.orderDetail.sm_name) + "]")]) : _vm._e()])])]), _c('div', {
    staticClass: "list-row-tr"
  }, [_c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('实际尺寸（CM）')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterSizeEmpty")(_vm.orderDetail.charge_info, 'charge_length', 'charge_width', 'charge_height')))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('订单状态')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.orderDetail.order_status_text)))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('是否退货')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("yesNoText")(_vm.orderDetail.is_return)))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('FBAshipmentID')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.orderDetail.fba_info ? _vm.orderDetail.fba_info.fba_shipment_id : '')))])])]), _c('div', {
    staticClass: "list-row-tr"
  }, [_c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('订单来源')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.orderDetail.create_type_text)))])]), _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }, [_vm._v(_vm._s(_vm.t('投保金额')))]), _c('div', {
    staticClass: "list-row-item list-row-value"
  }, [_vm._v(" " + _vm._s(_vm.isViewInsuranceValue ? _vm.orderDetail.value_added_service.insurance_value || '0.00' : '0.00') + " "), _vm.orderDetail.currency_code ? _c('span', {
    staticStyle: {
      "margin-left": "4px"
    }
  }, [_vm._v(_vm._s(_vm.orderDetail.currency_code))]) : _vm._e()])]), _vm._m(0), _vm._m(1)])])]);
};

var staticRenderFns = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }), _c('div', {
    staticClass: "list-row-item list-row-value"
  })]);
}, function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "list-row-td"
  }, [_c('div', {
    staticClass: "list-row-item list-row-label"
  }), _c('div', {
    staticClass: "list-row-item list-row-value"
  })]);
}];
export { render, staticRenderFns };